// extracted by mini-css-extract-plugin
export default {"styleboxcontainer":"StyleBox_styleboxcontainer__nS1k-","styleBoxMainContainer":"StyleBox_styleBoxMainContainer__UaDKJ"};